import React from 'react';
import { IconArrowLeft } from '@tabler/icons-react';

import { useAppDispatch, useTranslate, useWidgetsTheme as theme } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { OutlinedButton } from '@src/components/reusable';
import { Container } from './styles';
import { resetSelectedProduct } from '@src/stores/product';

const MultiProductCalendarPreviousStepButton = () => {
  const widgetId = useWidgetId();
  const dispatch = useAppDispatch();
  const actionColor = theme('actionColor');
  const { i18n } = useTranslate();

  const handleResetSelection = () => {
    dispatch(resetSelectedProduct(widgetId));
  };

  return (
    <Container>
      <OutlinedButton color={actionColor} onClick={handleResetSelection}>
        <IconArrowLeft size={20} />

        {i18n('adder_goBackFooter')}
      </OutlinedButton>
    </Container>
  );
};

export default MultiProductCalendarPreviousStepButton;
